<template>
    <iframe ref='signIframe' frameBorder="no" :src="iframeUrl" width='100%' height="860" style='border-bottom:1px solid #3D3D3D;'></iframe>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'

  export default {
    name: "SignFileShow",
    data () {
      return {
        iframeUrl: "",
        fileId:null,
      }
    },
    props: ['bidProjectId','sectionId','type','businessId'],
    watch: {
      businessId :{
        handler(newVal, oldVal){
          this.businessId = newVal
          this.showPdf()
        },
        immediate: true
      }
    },
    created () {
    },
    methods: {
      showPdf() {
        let that = this;
        if((that.sectionId == "" || that.sectionId == null) && (that.bidProjectId == "" && that.bidProjectId == null)) {
          return
        }
        getAction('/ebid-ce/unauthorized/getSignedPdfUrlMore', {
          sectionId: that.sectionId,
          bidProjectId: that.bidProjectId,
          businessId: that.businessId,
          type: that.type,
        }).then((res) => {
          if (res.success) {
            that.fileId=res.result.fileId
            that.signedPdfUrl=res.result.objectURL;
            // that.iframeUrl = `${window._CONFIG['frameDomainURL']}` + "/pdfjs/web/viewer.html?file=" + encodeURIComponent(that.signedPdfUrl);
            that.iframeUrl = that.signedPdfUrl;
            that.$refs.signIframe.height=860;
          } else{
            that.$message.error("签章文件不存在！");
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
